import Axios from 'axios';
export default class Pedidos {
    static buscarPedidos(search, page){
        let params = {search: search, page: page}
        return new Promise((resolve, reject)=>{
            Axios.get('pedidos',{params:params}).then((e)=>{
                return resolve(e.data)
            }).catch(()=>{
                return reject(null)
            })
        })
    }
    static getPedido(id){
        return new Promise((resolve, reject)=>{
            Axios.get('pedidos/'+id).then((e)=>{
                return resolve(e.data.pedido);
            }).catch(()=>{
                return reject(null)
            })
        })
    }
    static actualizarPedido(id, data){
        return new Promise((resolve, reject)=>{
            Axios.put('pedidos/'+id, data).then((e)=>{
                return resolve(e.data);
            }).catch((error)=>{
                return reject(error)
            })
        })
    }
    static reenviarPedido(data){
        return new Promise((resolve, reject)=>{
            Axios.get('reenviarPedido', {params:data}).then((e)=>{
                return resolve(e.data);
            }).catch(()=>{
                return reject(null)
            })
        })
    }
    static descargarPedido(data){
        return new Promise((resolve, reject)=>{
            Axios.get('descargarPedido', {params:data, responseType: 'arraybuffer'}).then((e)=>{
                return resolve(e.data);
            }).catch(()=>{
                return reject(null)
            })
        })
    }
}
